module.exports = __webpack_public_path__ + "img/pay-ali-selected.e1710a65.png";